import React from 'react';
import styled from 'styled-components/macro';
import { Typography } from '@deeptrue-frontend/ui';
import { useFormatMessage } from 'components/IntlProvider/hooks/hooks';

const StyledTabs = styled.ul`
  background-color: #ffffff;
  list-style-type: none;
  display: flex;
  width: 100%;
  padding: 0;
  margin: 0;
  border-bottom: 1px solid #e6e6e5;
  min-height: 2.5rem;
  padding-left: 2rem;
  li:first-of-type {
    margin-left: 0;
  }
  li:last-of-type {
    margin-right: 0;
  }
`;

const StyledTab = styled.li<{ isActive: boolean }>`
  padding: 0.5rem 0;
  margin: 0 1rem;
  cursor: pointer;
  text-transform: capitalize;

  ${({ isActive }) =>
    isActive &&
    `
    border-bottom:2px solid #1F5DEA;

    p {
      color:#1F5DEA;
    }
  `}
`;

export enum Tabs {
  'reportRecommendations' = -1,
  'results' = 0,
  'specification',
  'files',
}

interface Props {
  selectedTab: number;
  changeTab: (value: number) => void;
  tabs: ['results', 'specification', 'reportRecommendations', 'files'];
}

const ReportTabs = ({ selectedTab, changeTab, tabs }: Props) => {
  const t = useFormatMessage();

  const isResultsTab = tabs.includes('results');
  const isSpecificationTab = tabs.includes('specification');
  const isRecommendationTab = tabs.includes('reportRecommendations');
  const isFilesTab = tabs.includes('files');

  return (
    <StyledTabs>
      {isRecommendationTab && (
        <StyledTab
          isActive={selectedTab === Tabs.reportRecommendations}
          onClick={() => changeTab(Tabs.reportRecommendations)}
        >
          <Typography fontSize="0.875rem">
            {t('reports.default.menu.insights', 'Insight Summary')}
          </Typography>
        </StyledTab>
      )}
      {isResultsTab && (
        <StyledTab
          isActive={selectedTab === Tabs.results}
          onClick={() => changeTab(Tabs.results)}
        >
          <Typography fontSize="0.875rem">
            {t('reports.default.menu.results', 'Results')}
          </Typography>
        </StyledTab>
      )}
      {isSpecificationTab && (
        <StyledTab
          isActive={selectedTab === Tabs.specification}
          onClick={() => changeTab(Tabs.specification)}
        >
          <Typography fontSize="0.875rem">
            {t('reports.default.menu.specification', 'Specifications')}
          </Typography>
        </StyledTab>
      )}
      {isFilesTab && (
        <StyledTab
          isActive={selectedTab === Tabs.files}
          onClick={() => changeTab(Tabs.files)}
        >
          <Typography fontSize="0.875rem">
            {t('pages.project.files', 'Files')}
          </Typography>
        </StyledTab>
      )}
    </StyledTabs>
  );
};

export default ReportTabs;
